import React from "react";
import { SimilarSearchResult } from "./SearchPageResult";
interface Props {
  similarSearchResults: SimilarSearchResult[];
  bottomMetaDescription: string;
}
const SimilarSearchResultsView = ({
  similarSearchResults,
  bottomMetaDescription
}: Props) => <>
    <div className="mx-2.5 xs:mx-0 lt:mx-[5px] leading-none">
      <p id="relatedsearches" className="font-semibold mb-3">
        Related Searches
      </p>
      <ul className="list-none p-0 m-0" aria-labelledby="relatedsearches">
        {similarSearchResults.map(tag => <li key={tag.searchTerm} className="inline-block">
            <a href={`${tag.searchTermUrl}.html`} className="
            text-sm font-medium text-gray-900 p-1 inline-block bg-gray-50 border-solid
            border border-gray-200 shadow-sm rounded overflow-hidden whitespace-nowrap
            hover:border-gray-500 shadow-xs transition duration-100 ease-in">
              {tag.searchTerm}
            </a>
            &nbsp;
          </li>)}
      </ul>
    </div>
    <div id="adcontainer1" className="box padded hide" />
    {!!bottomMetaDescription?.length && <div className="padded-subtle small"
  // eslint-disable-next-line react/no-danger
  dangerouslySetInnerHTML={{
    __html: bottomMetaDescription
  }} />}
  </>;
export default SimilarSearchResultsView;